module.exports = __webpack_public_path__ + "static/media/ico-create.9a41cded.svg";